var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasRequirements || _vm.links.length > 0
    ? _c(
        "div",
        { staticClass: "library" },
        [
          _vm.title
            ? _c("SidebarTitle", { attrs: { title: _vm.title } })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "library__list" },
            [
              _vm._l(_vm.links, function (item, index) {
                return _c(
                  "div",
                  { key: index, staticClass: "library__item" },
                  [
                    item.update_date
                      ? _c("Info", {
                          attrs: {
                            text: "UPDATED " + item.update_date,
                            arrow: true,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("Button", {
                      attrs: { text: item.title, link: _vm.resolveLink(item) },
                    }),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _vm.hasRequirements
                ? _c("Button", {
                    attrs: {
                      text: _vm.jurisdictionName + `   Requirements`,
                      link: `/requirement?id=${_vm.jurisdictionId}&cid=${_vm.jurisdictionChildId}`,
                    },
                  })
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }